export type ToastAlertProps = {
  showNotification: boolean;
  message: string;
  priority: AlertPriority | null;
};

export enum AlertPriority {
  notification = 'notification',
  warning = 'warning',
  success = 'success',
  alert = 'alert',
}
